((win) => {
    let TESTBANKS_URI = ``
    let TESTBACNK_ORIGIN_URI = ``
  
    if (window.location.hostname === "a-dev.tbbt.com.tw"){
      TESTBANKS_URI = `https://testbank.tbbt.com.tw/edisc3.html`
      TESTBACNK_ORIGIN_URI = `https://testbank.tbbt.com.tw`
  
    } else if (window.location.hostname === "qa-textbook.hle.com.tw"){
      TESTBANKS_URI = `https://testbank.tbbt.com.tw/edisc3.html`
      TESTBACNK_ORIGIN_URI = `https://testbank.tbbt.com.tw`
  
  
    }else if (window.location.hostname === "textbook.hle.com.tw" ) {
      TESTBANKS_URI = `https://testbank.hle.com.tw/edisc3.html`
      TESTBACNK_ORIGIN_URI = `https://testbank.hle.com.tw`
  
  
    } else if (window.location.hostname === "qa-reference.hle.com.tw" ) {
      TESTBANKS_URI = `https://testbank.tbbt.com.tw/edisc3.html`
      TESTBACNK_ORIGIN_URI = `https://testbank.tbbt.com.tw`
  
  
    } else if (window.location.hostname === "reference.hle.com.tw" ) {
      TESTBANKS_URI = `https://testbank.hle.com.tw/edisc3.html`
      TESTBACNK_ORIGIN_URI = `https://testbank.hle.com.tw`
  
    } else {
      TESTBANKS_URI = `https://testbank.tbbt.com.tw/edisc3.html`
      TESTBACNK_ORIGIN_URI = `https://testbank.tbbt.com.tw`
  
    }
    win.addTestBankLink = async function addTestBankLink(edu){
      if (edu === "國中" || edu === "高中"){
        // const item2 = document.getElementById("item-2")
        let url = new URL(window.location.href)
  
        // 先尋找 url 中是否有 accessToken，有的話加到 sessionStorage
        // 再尋找 sessionStorage 中是否有 accessToken
        // 如果都沒有，則使用 authSvc.getUser() 取得 accessToken
  
        let urlAccessToken = url.searchParams.get("token")
        if (urlAccessToken !== null) sessionStorage.setItem("accessToken", urlAccessToken)
        let sessionAccessToken = sessionStorage.getItem("accessToken")
  
        if (sessionAccessToken === null){
          let user = await authSvc.getUser()
          if (user !== null){
            sessionStorage.setItem("accessToken", user.access_token)
          }
        }
        const accessToken = sessionStorage.getItem("accessToken")
        let openTestBank = ""
        let sendTestBank = ""
  
        if (accessToken !== null && accessToken !== "" && accessToken !== undefined) {
          openTestBank = TESTBANKS_URI + "?route=MATERIAL_WITH_POPUP&token=" + accessToken
          sendTestBank = TESTBANKS_URI + "?route=MATERIAL&token=" + accessToken
        } else {
          openTestBank = TESTBACNK_ORIGIN_URI
          sendTestBank = TESTBACNK_ORIGIN_URI
        }
  
        // item2.innerHTML = `
        // <p>立即前往翰林雲端命題大師，即可【<a href="${openTestBank}" target="_blank">開通輔材試卷</a>】或【<a href="${sendTestBank}" target="_blank">派發速測卷</a>】。</p>
        // `
      }
    }
  
  })(window)
  